<div class="wrapper">
  <div class="main">
    <div class="fixed-nav">
      <app-physical-navbar></app-physical-navbar>
    </div>
    <div class="view-block">
      <div class="router-block">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
